export default __webpack_public_path__ + "static/media/highlighter.224e5c09.png";